import Footer from "../components/home/footer"
import Header from "../components/home/header"
import Paymentfailed from '../assets/payment/credit-card.gif'
const failed=()=>{
    return(
        <>
            <Header/>
            <div className="container-fluid">
                <div className="container text-center d-flex justify-content-center align-items-center" style={{
                    height:'90vh',
                }}>
                    <div>
                    <img src={Paymentfailed} alt="payment failed"  style={{
                        width:'400px',
                        height:'400px'
                    }}/>
                    <p style={{fontWeight:600}}>Payment failed</p>
                    </div>
                </div>
            </div>    
            <Footer/>
        </>
    )
}
export default failed